import React, { Component } from 'react';
import {
    Link,
    Redirect
} from "react-router-dom";
import { Formik } from 'formik';
import _ from 'lodash';
import config from '../config';
import JsonEditorComponent from '../JsonEditorComponent'
import {AuthContext} from "../context/auth";
import fetcher from "../context/fetcher";
import {downloadFile, readFileAsync} from "../components/ImportExport";

export default class Withdrawals extends Component {
    static contextType = AuthContext
    constructor(props, context) {
        super(props);
        this.authContext = context;
        this.collectionName = "users-withdrawals";
        this.keys = ["status", "currency", "userId", "destination",  "starsAmount", "amount"];
        this.state = {query: {}};
        this.init = this.init.bind(this);
        this.reject = this.reject.bind(this);
        this.apply = this.apply.bind(this);
        this.init();
    }

    async init(query)  {
        fetcher(`${config.API()}dbtable/${this.collectionName}?` + new URLSearchParams(Object.assign({
            page: 0
        }, query)))
        .then(response => response.json())
        .then(data => {
            this.setState({query: query, objs: data.items, total: data.total})
        });

        fetcher(`${config.API()}withdrawals/info`)
            .then(response => response.json())
            .then(data => {
                this.setState({info: data})
            });
    }



    apply = (id) => {
        return (e) => {
            let isOk = window.confirm("Are you sure?");
            if(!isOk)
                return;
            fetcher(`${config.API()}withdrawals/apply`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id
                })
            })
                .then(response => response.json())
                .then(data => {
                    let objs = this.state.objs;
                    let o = _.find(objs, x => x._id == id)
                    o.status = "completed";
                    this.setState({objs})
                });
        }
    }

    reject = (id) => {
        return (e) => {
            let isOk = window.confirm("Are you sure?");
            if(!isOk)
                return;
            fetcher(`${config.API()}withdrawals/reject`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id
                })
            })
                .then(response => response.json())
                .then(data => {
                    let objs = this.state.objs;
                    let o = _.find(objs, x => x._id == id)
                    o.status = "rejected";
                    this.setState({objs})
                });
        }
    }


    render() {

        if (this.state.redirect) {
            return <Redirect push to={this.state.redirect} />;
        }


        const query = new URLSearchParams(this.props.location.search);
        let newQuery = {
            page: query.get("page") || 0
        }

        if (!_.isEqual(newQuery, this.state.query)) {
            this.init(newQuery);
            return (<div></div>);
        }

        let pages = []
        let page = parseInt(this.state.query.page) || 0
        let lastPage = Math.floor(this.state.total / 100)

        if(page == 0) {
            pages.push(page)
            if(page+1 <= lastPage)
                pages.push(page+1)
            if(page+2 <= lastPage)
                pages.push(page+2)
        }else if(page == lastPage){
            if(page-2 >=0)
                pages.push(page-2)
            if(page-1 >=0)
                pages.push(page-1)
            pages.push(page)
        }else{
            if(page-1 >=0)
                pages.push(page-1)
            pages.push(page)
            if(page+1 <= lastPage)
                pages.push(page+1)
        }

        return (
            <div>
            <div className="card shadow w100">
                <div className="card-header py-3">
                    <h2 className="m-0 font-weight-bold l"> Withdrawal requests </h2>
                </div>

                <div className="card-body">
                    <div>
                        <div className="form-group row">
                            <div className="col-sm-5 form-control">Solana Wallet: {this.state.info && this.state.info.walletAddress}</div>
                            <div className="col-sm-2 form-control">SOL: {this.state.info && this.state.info.solBalance}</div>
                        </div>
                        <div className="form-group row">
                            <div className="col-sm-5 form-control">Somnia Wallet: {this.state.info && this.state.info.somniaWalletAddress}</div>
                            <div className="col-sm-2 form-control">SOMI: {this.state.info && this.state.info.somiBalance}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="r p-2 pr-4">
                                <ul className="pagination">
                                    <li className={"page-item " + (page == 0 ? "disabled" : "")}>
                                        {page != 0 && <Link className="page-link" to={"/withdrawal?"+ new URLSearchParams(Object.assign(newQuery, {page:page-1}))}>Previous</Link>}
                                        {page == 0 && <span className="page-link">Previous</span>}
                                    </li>
                                    { pages.map((p,i) =>
                                        <li key={`p`+p} className={`page-item ${page == p ? "active" : ""}`}>
                                            <Link className="page-link" to={"/withdrawal?" + new URLSearchParams(Object.assign(newQuery, {page:p}))}>{ p+1 }</Link>
                                        </li>
                                    )}
                                    <li className={"page-item " + (page == lastPage ? "disabled" : "")}>
                                        {page != lastPage && <Link className="page-link" to={"/withdrawal?"+ new URLSearchParams(Object.assign(newQuery, {page:page+1}))}>Next</Link>}
                                        {page == lastPage && <span className="page-link">Next</span>}
                                    </li>
                                </ul>
                            </div>
                            <div className="r p-2 pr-4 pt-3">Showing {page+1} to {lastPage+1} of {this.state.total}</div>
                        </div>
                    </div>
                    <div className="table-responsive">
                        <table className="dataTable table table-align-middle table-bordered table-sm" width="100%"
                               cellSpacing="0">
                            <thead>
                            <tr>
                                <th>Created</th>
                                {this.keys.map((k) => <th className="text-capitalize">{k}</th>)}
                                <th>Links</th>
                                <th></th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.objs && this.state.objs.map((x,i) =>
                                <tr key={x._id} className={ x.status=="completed" ? "text-success" : (x.status=="rejected" || x.status=="reject" ? "text-danger" : "")  }>
                                    <td>
                                        {x.createdAt.slice(0, 19).replace("T", " ")}
                                    </td>
                                    {this.keys.map((k) => <td>{x[k]}</td>)}
                                    {x.currency=="sol" &&
                                        <td>
                                            <a href={`https://explorer.solana.com/address/${x.destination}?cluster=devnet`} target="_blank" className="btn btn-outline-info btn-circle btn-sm">W</a> <a href={`https://explorer.solana.com/tx/${x.hash}?cluster=devnet`} target="_blank" className="btn btn-outline-info btn-circle btn-sm">E</a>
                                        </td>
                                    }
                                    {x.currency=="somi" &&
                                        <td>
                                            <a href={`https://shannon-explorer.somnia.network/address/${x.destination}`} target="_blank" className="btn btn-outline-info btn-circle btn-sm">W</a> <a href={`https://shannon-explorer.somnia.network/tx/${x.hash}`} target="_blank" className="btn btn-outline-info btn-circle btn-sm">E</a>
                                        </td>
                                    }
                                    <td>
                                        {x.status == "pending" && <button className="btn btn-outline-danger btn-sm" onClick={this.reject(x._id)} ><i className="fa fa-remove"></i> reject</button>}
                                    </td>
                                    <td>
                                        {x.status == "pending" && <button className="btn btn-outline-primary  btn-sm" onClick={this.apply(x._id)} ><i className="fa fa-money"></i> confirm</button>}
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>

            </div>
        );
    }
}
